import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../_shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { EditListDialogComponent } from './components/edit-list-dialog/edit-list-dialog.component';
import { CoverSelectionDialogComponent } from './components/cover-selection-dialog/cover-selection-dialog.component';
import { NgxsModule } from '@ngxs/store';
import { EditListState } from './state/edit-list.state';



@NgModule({
  declarations: [
    EditListDialogComponent,
    CoverSelectionDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    NgxsModule.forFeature([EditListState]),
  ],
  exports: [
    EditListDialogComponent,
  ],
})
export class EditListModule { }
